<template>
  <div
    class="group relative w-full cursor-pointer rounded-lg border border-dashed border-main p-8 hover:border-strong"
    data-testid="partner-dropper"
  >
    <input
      multiple
      type="file"
      class="absolute inset-0 z-50 h-full w-full opacity-0"
      :accept="accept"
      data-testid="partner-dropper-input"
      @change="onFilesPicked"
    />
    <div class="text-center text-subtlest group-hover:text-main">
      <MdiSvg class="mx-auto" :path="mdiUpload" size="20" />
      <p class="txt-body-s-regular">
        {{ props.imageDimensionsHint }}
      </p>
      <p class="txt-body-s-regular">
        {{ props.fileFormatsHint }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { mdiUpload } from '@mdi/js'
import { MdiSvg } from '@ramp106/omrjs-core-ui'

export interface Props {
  accept?: string
  error?: string
  fileFormatsHint?: string
  imageDimensionsHint?: string
}

const props = withDefaults(defineProps<Props>(), {
  accept: '*',
  error: undefined,
  fileFormatsHint: undefined,
  imageDimensionsHint: undefined,
})

const emit = defineEmits<{
  (e: 'input', file: FileList): void
}>()

function onFilesPicked(evt: Event) {
  const el = evt.target as HTMLInputElement
  if (el.files?.length) {
    emit('input', el.files)
  }
}
</script>
